import { getI18nLanguage, i18nRender } from '@/locales'
import jsSHA from 'jssha'
import Vue from 'vue'
import { ACCESS_TOKEN, USERID } from '@/store/mutation-types'

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? i18nRender('user.good.morning') : hour <= 11 ? i18nRender('user.good.morning') : hour <= 13 ? i18nRender('user.good.noon') : hour < 20 ? i18nRender('user.good.afternoon') : i18nRender('user.good.evening')
}

export function getRequestSignHeader (url) {
  const config = {}
  const token = Vue.ls.get(ACCESS_TOKEN)
  const userid = Vue.ls.get(USERID)
  if (token) {
    config['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    config['USERID'] = userid
    config['clienttype'] = 'pc'
  }
  const args = {}
  args.requesturl = url
  args.requesttime = (new Date()).getTime()
  args.requestnonce = Math.random().toString(36).substr(2, 15)
  config['accept-language'] = getI18nLanguage()
  config['requesttime'] = args.requesttime
  config['requestnonce'] = args.requestnonce
  var keys = Object.keys(args)
  keys = keys.sort()
  var newArgs = {}
  keys.forEach(function (key) {
    newArgs[key] = args[key]
  })

  var string = ''
  for (var k in newArgs) {
    if (newArgs[k] !== undefined && newArgs[k] !== null) {
      string += '&' + k + '=' + encodeURIComponent(newArgs[k])
    }
  }
  string = string.substr(1)

  // eslint-disable-next-line new-cap
  var shaObj = new jsSHA('SHA-1', 'TEXT')
  shaObj.update(string)
  var signature = shaObj.getHash('HEX')
  config['sign'] = signature
  return config
}

export function welcome () {
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}
